import { CustomerType } from "@origin-digital/platform-enums";
import { IMcAppType, NavFlow, Tab } from "../mcApp.types";

export const messageUs: IMcAppType = {
  name: "messageUs",
  path: "/my/message-us",
  description: "Message Us",
  navFlow: NavFlow.STANDARD,
  title: "Message Us",
  parent: Tab.MORE,
  conditions: {
    intent: "messageUs",
    customerType: CustomerType.kraken,
  },
};

export const messageUsMarvin: IMcAppType = {
  name: "messageUsMarvin",
  path: "/my/odin-chat-client-app",
  description: "Marvin chat client",
  navFlow: NavFlow.MODAL,
  title: "",
  parent: Tab.MORE,
  parameters: {
    properties: {
      disableAndroidPullToRefresh: {
        type: "boolean",
        description:
          "Disables native pull-to-refresh on Android for this route",
        const: true,
      },
    },
  },
  conditions: {
    intent: "messageUsMarvin",
    customerType: CustomerType.kraken,
  },
};
